import React from 'react';
import { useTranslation } from 'react-i18next';

import CloseIcon from '../../../assets/images/close-icon.svg';
import defaultProfileImg from '../../../assets/images/default_profile_img.svg';
import ButtonWithIcon from '../../../components/shared/ButtonWithIcon/ButtonWithIcon';
import ShareModalButton from '../../Browse/SocialShareButton/SocialShareButton';

import JobModal from './JobShareModal/JobModal';

import styles from './ShareModal.module.scss';

const ShareModal = ({ isOpen, onClose, company, handleSocialShare, onCopyLink }) => {
  const { t } = useTranslation('common');
  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div>
            <h2>{t('share.shareWithCommunity')}</h2>
            <div className={styles.closeButtonPosition}>
              <ButtonWithIcon
                img={CloseIcon}
                imgClassName="btn-icon-circular"
                variant="only-icon-circular-tertiary"
                onClick={onClose}
              />
            </div>
          </div>
        </div>
        {company.type === 'companyProfile' ? (
          <div className={styles.borderContainer}>
            <div className={styles.content}>
              <div className={styles.companyInfo}>
                <div className={styles.logo}>
                  <span>
                    <img src={company.logo || defaultProfileImg} alt="profile-bg" className={styles.logo} />
                  </span>
                </div>
                <div>
                  <h3 className={styles.companyName}>{company.name}</h3>
                  <div className={styles.companyPreviewInfo}>
                    <div>{company.industry}</div>
                    <div>{company.employeeRange}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <JobModal job={company} />
        )}
        <ShareModalButton handleSocialShare={handleSocialShare} onCopyLink={onCopyLink} />
      </div>
    </div>
  );
};

export default ShareModal;
